<template>
  <v-container >
    <v-layout wrap justify-start>
      <v-flex align-self-center md5 py-10>
        <v-flex py-1 md12>
          <v-layout>
            <v-flex xs7 md6>
              <v-img :src="require('../assets/accenta.jpg')">
              </v-img>
            </v-flex>
          </v-layout>

          <v-layout wrap justify-start>
            <v-flex md12  pb-9 style="color:white">
              <span style="font-family:poppinsmedium;font-size:44px">OUR WEBSITE IS <SPAN style="font-family:poppinsmedium;font-size: 55px"> <b> COMING SOON</b></SPAN> </span>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-start style=" color:white">
            <v-flex text-left  md12>
              <span style="font-family:poppinsmedium;font-size:25px">Meanwhile feel free to contact us </span>
            </v-flex>
            <v-layout justify-start wrap>
              <v-flex text-left style="font-family:poppinsmedium;font-size:22px" md12>
                <span> Phone: +91 9946789898 </span><br>
                <span>Email: info@accenta.in</span>

              </v-flex>
            </v-layout>
          </v-layout>
            <v-layout wrap justify-start>
              <!-- <v-flex md5 text-left md12 style="color:white">
                
              </v-flex> -->
              <v-flex py-2 align-self-start md4>
                <v-btn
                style="background-color:white;"
                  elevation="2"
                  rounded
                  text
                  class="text-capitalize"
                >
                <a style="color:white" href="mailto:info@accenta.in">
                  <span style="font-family:poppinsmedium;color:#ffcb0b;font-size:22px">Send Mail</span>
                  <!-- <v-icon>mdi-email-outline</v-icon> -->
                </a>

                </v-btn>
              </v-flex>
            </v-layout>
        </v-flex>

      </v-flex>

      <v-flex py-12 m12>
        <v-layout wrap justify-start>
          <v-flex py-12 md12>
            <v-flex py-12>
              <v-img
                    :src="require('../assets/PaperPlane_Vector.svg')"
                    height="100%"
                  >

              </v-img>

            </v-flex>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'HelloWorld',

  }
</script>
